export const CompletedIcon = (props: React.SVGProps<SVGSVGElement>) => (  
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="16" cy="16" r="16" fill="white"/>
        <path d="M23.3307 11.1562L13.2474 20.8363L8.66406 16.4363" stroke="#0C1C2C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
);
